import * as React from 'react';
import { goToHome } from 'src/utils/navigation';

import AccountCard from './components/AccountCard';
import Alert from './components/Alert';

import './AccountSwitch.scss';

export default class AccountSwitch extends React.Component<any, any> {
  constructor(props: any) {
    super(props);

    this.state = {
      alertIsShown: false
    };
  }

  private handleCloseAlert = () => {
    this.props.changeActiveAccountFlag(false);
  };

  private renderAccounts = () => {
    let items = [];
    items = this.props.accounts.map((item: any, index: any) => {
      return (
        <AccountCard
          key={index}
          accountId={item.accountId}
          accountName={item.name}
          isActive={this.props.activeAccount === item.accountId}
          action={() => {
            this.props.changeActiveAccount(item.accountId, item.userId);
          }}
        />
      );
    });
    return items;
  };

  private renderHeader = (t: any) => {
    switch (this.props.accountHasChanged) {
      default:
      case false:
        return (
          <div className="account-switch--header">
            <h1 className="title h1">
              {this.props.activeAccount
                ? t('accountSwitch.switchAccount')
                : t('accountSwitch.selectAccount')}
            </h1>
            <p className="title--subtitle">
              {this.props.activeAccount
                ? t('accountSwitch.switchAccountSubtitle')
                : t('accountSwitch.selectAccountSubtitle')}
            </p>
          </div>
        );
      case true:
        // TODO: change svg to font
        return (
          <div className="account-switch--header">
            <Alert
              type="error"
              styleClass="sign-in--error-alert"
              onCloseAction={this.handleCloseAlert}
            >
              {t('accountSwitch.accountSwitched')}
            </Alert>
          </div>
        );
    }
  };

  private shouldGoToHome = () => {
    if (
      this.props.location.pathname.includes('login') &&
      this.props.accountHasChanged
    ) {
      this.props.changeActiveAccountFlag(false);
      goToHome();
    }
  };

  public componentDidMount = () => {
    this.props.getAccounts();
    this.shouldGoToHome();
  };

  public componentDidUpdate = (prevProps: any, prevState: any) => {
    this.shouldGoToHome();
  };

  public componentWillUnmount = () => {
    this.props.changeActiveAccountFlag(false);
  };

  public render() {
    const t = this.props.t;
    if (this.props.accounts != null && this.props.accounts.length <= 1) {
      return <div className="account-switch--container" />;
    }
    return (
      <div className="account-switch--container">
        {this.renderHeader(t)}
        <div className="account-switch--content">
          <div className="account-switch--accounts">
            {this.renderAccounts()}
          </div>
        </div>
      </div>
    );
  }
}
